import {atomWithHash} from "jotai-location";

export const reportsParamsAtom = atomWithHash<Object>('reportsParams', {});
export const managedReportsParamsAtom = atomWithHash<Object>('managedReportsParams', {});
